/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState, memo } from 'react';
import { isEmpty } from 'lodash';
import { message } from 'antd';
import Icons from '../../../configs/icon.config';
import Translate from '../Translate';

interface CopyButtonProps {
  text: string;
}

function CopyButton({ text }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    try {
      if (!isEmpty(text)) {
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 2000);
      }
    } catch (error) {
      // Handle the error here
      message.error('An error occurred while copying the text.');
    }
  };

  return (
    <div
      className="flex items-center space-x-1  px-2 rounded text-pink-800 dark:text-[#EB3E8E] text-lg  focus:outline-none cursor-pointer"
      onClick={handleCopy}
    >
      {Icons.copy}
      <span className="underline">
        <Translate
          en={copied ? 'Copied!' : 'Copy'}
          bn={copied ? 'কপি হয়েছে!' : 'কপি'}
        />
      </span>
    </div>
  );
}

export default memo(CopyButton);
